module.exports = __webpack_public_path__ + "img/sources.56126b5d.svg";